import { useNavigate } from "react-router-dom";
import { INftAsset } from "../../../../interfaces"
import { Utils } from "../../../../utils"

interface NftCreatorAssetCardProps {
  asset: INftAsset
}
export const NftCreatorAssetCard = ({ asset }: NftCreatorAssetCardProps) => {
  const projectCode: string = 'NFT';
  const navigate = useNavigate();
  return (
    <div className="cards d-flex flex-column justify-content-between align-items-center mx-auto w-100" onClick={() => {
      navigate(`/web/asset/detail/${asset.nftId}`)
    }}>
      <div className="d-flex justify-content-center align-items-baseline" style={{ height: '220px' }}>
        <img
          src={Utils().normalizeImagePath(asset.image, projectCode)}
          alt=""
          className="" style={{ maxHeight: '100%', maxWidth: '100%' }}
        />
      </div>
      <div className="p-3 weight-600">
        {asset.name}
      </div>
    </div>
  )
}